import { Content } from "@omni/ui/components/CallToAction/types/content.types";
import classnames from "classnames";

type CallToActionContentProps = Content;

const CallToActionContent = ({
    text,
    iconClassName,
    iconPosition
}: CallToActionContentProps) => (
    <>
        {iconClassName && iconPosition === "start" && (
            <i
                className={classnames("las la-lg mr-2", `la-${iconClassName}`)}
            />
        )}
        {text}
        {iconClassName && iconPosition === "end" && (
            <i
                className={classnames("las la-lg ml-2", `la-${iconClassName}`)}
            />
        )}
    </>
);

export { CallToActionContent };
